const PanelHeader = ({ children, className = '', style = {} }) => {
  return (
    <div className={`comp-panel-header ${className}`} style={style}>
      {children}
    </div>
  );
};

export default PanelHeader;
